import { Button, Chip, CircularProgress, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { getUserName } from "../../api/lensService";
import { useEffect, useMemo, useState } from "react";
import { createJiraTicket, getJiraStatus, loadJiraProjects, loadJiraStatuses, loadJiraUsers, updateJiraTicket, updateTestResult } from "../../api/jira.service";


export const JiraTicketDetail = ({
    testResultDetails = null,
    alertSettingDetail=null,
    project = null,
    cancel = null,
    channel = null,
    scheduled = '',
    attachJiraTicketdetail = "",
    onSaveChanges, // Callback function from parent
}) => {
    const { t } = useTranslation();
    const [users, setUsers] = useState([]);
    const [loading, isLoading] = useState(true);
    const [projects, setProjects] = useState([]);
    const [statuses, setStatus] = useState([]);

    // const url = useMemo(() => 
    //     `${document.location.protocol}//${document.location.host}/projects/${project?.testProjectID}${scheduled ? '/scheduled' : ''}/testresults/${scheduled || testResultDetails?.testCaseId || testResultDetails?.id}/${testResultDetails?.testResult?.id}`,
    //     [testResultDetails, project]
    // );
    const url = "";
   

    const formik = useFormik({
        initialValues: {
            labels: '',
            tags: [],
            summary: '',
            assignee: '',
            project: '',
            username: '',
            status: '',
        },
    });

    console.log(alertSettingDetail);
    const saveChanges = async () => {
        // Get the values of assignee and project
        const { assignee, project, username } = formik.values;

        // Pass the values to the parent component via the callback
        if (onSaveChanges) {
            onSaveChanges({ assignee, project, username });
        }

        // Optionally close the modal
        cancel && cancel();
    };

    useEffect(() => {
        const loadUsers = async () => {
            const data = await loadJiraUsers();
            setUsers(data);

            const projects = await loadJiraProjects();
            setProjects(projects);
       
            formik.setValues({
                assignee: alertSettingDetail?.jiraAssignee,
                project: alertSettingDetail?.jiraProject,
                username: alertSettingDetail?.jiraUsername,
            });
            
            isLoading(false);
        };

        loadUsers();
    }, []);

    return (
        <>
            {loading && <div className="data-loader"><CircularProgress /> <span>&nbsp;&nbsp;&nbsp;&nbsp;Please wait ...</span></div>}

            <Grid container spacing={3} sx={{ mt: 3, pl: 3 }}>
                 {/* Conditionally render the rest of the UI only if attachJiraTicketdetail is false */}
            
                    <Grid item xs={12} className="jira-details-header bg-light-green" sx={{ mt: 2 }}>
                    </Grid>
                    <Grid item xs={4} className="bg-light-green">
                        <TextField
                            label={t('Assignee *')}
                            InputLabelProps={{ shrink: true }}
                            select
                            fullWidth
                            onChange={formik.handleChange}
                            value={formik.values.assignee}
                            name="assignee"
                            id="assignee"
                        >
                            {users.map(user => (
                                <MenuItem value={user.accountId} key={user.accountId}>{user.name}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={4} className="bg-light-green">
                        <TextField
                            label={t('Project *')}
                            InputLabelProps={{ shrink: true }}
                            select
                            fullWidth
                            onChange={formik.handleChange}
                            value={formik.values.project}
                            name="project"
                            id="project"
                        >
                            {projects.map(project => (
                                <MenuItem value={project.key} key={project.key}>{project.name}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={4} className="bg-light-green">
                        <TextField
                            label={t('Username *')}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            onChange={formik.handleChange}
                            value={formik.values.username}
                            name="username"
                            id="username"
                        />
                    </Grid>
              
                    <Grid item xs={12} className="bg-light-green" sx={{ pr: 3, pb: 3, pt: 2 }} style={{ display: 'flex', gap: '40px', justifyContent: 'center' }}>
                        <Button variant='contained' onClick={cancel}>
                            <Typography>{t('Cancel')}</Typography>
                        </Button>

                        <Button variant='contained' onClick={saveChanges}>
                            <Typography>{t('Save Changes')}</Typography>
                        </Button>
                    </Grid>
            </Grid>
        </>
    );
};